<template>
  <div>
    <textarea class="textarea"></textarea>
    <el-row type="flex" justify="space-between" class="textarea-bottom">
      <div>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconbiaoqing"></use>
        </svg>
      </div>
      <div>
        <span class="explain">还能输入600个字</span>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'textContent',
  data() {
    return {}
  },
  components: {},
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.icon {
  font-size: 16px;
  color: #5e656e;
}
.textarea {
  width: 100%;
  height: 180px;
  border: none;
  padding: 6px 10px;
  resize: none;
  outline: none;
}

.textarea-bottom {
  padding: 5px 10px 10px;

  .explain {
    color: #b2b2b2;
  }
}
</style>
